import type { DictionaryData } from './react-i18n/types';

import type { I18Lang, SupportedLang } from './constants';
import isUseTranslationData from './react-i18n/is-use-translation-data';
import Trans from './react-i18n/Trans';
import { type tFunction, useTranslation } from './react-i18n/useTranslation';
import { LanguageStore } from './utils/languageStore';
import { getSupportedLang, isSupportedLang } from './utils/supported-lang-functions';

// ---

export { I18N_NAMESPACE } from './constants';
export * from 'app/constants/locales';
export * from './redux/action';
export {
  LanguageStore,
  isUseTranslationData,
  isSupportedLang,
  getSupportedLang,
  DictionaryData,
  tFunction,
  I18Lang,
  SupportedLang,
  useTranslation,
  Trans,
};
